<template>
  <div class="video_box">
    <video-player id="video" class="video-player vjs-custom-skin"
      v-loading="videoLoading"
      element-loading-text="视频加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, .1)"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      @
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @playing="onPlayerPlaying($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @ended="onPlayerEnded($event)"
      @error="onPlayerErro($event)"
      @statechanged="playerStateChanged($event)"
      muted
      >
    </video-player>
    <!-- <div v-if="videoType === 'index'" class="video_player_shadow" @click="videoPalyer()"> -->
      <!-- div v-show="!liveBtnList.playOnOff" class="video_player_icon_box">
        <i class="my_icon_list player_icon_big" @click.stop="videoPalyer()"></i>
      </div> -->
    <!-- </div> -->
    <div v-if="videoType === 'index'" class="video_index_control">
      <div class="video_index_player lf">
        <i v-if="!liveBtnList.playOnOff" class="iconfont icon-play1" @click="videoPalyer()"></i>
        <i v-else class="iconfont icon-suspended" @click="videoPalyer()"></i>
      </div>
      <div class="video_index_btn rt">
        <button v-if="detail.price === '0.00'" class="el-button" @click="jump(detail.type, detail.list_id, detail.nav_id, detail.is_doing)">点击进入详情</button>
        <button v-if="detail.price !== '0.00'" class="el-button" @click="buyMoney()">点击购买</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'videoModel',
  props: ['srcArr', 'bgImg', 'videoType', 'detail'],
  data () {
    return {
      videoLoading: false,
      liveBtnList: {
        // 进度条
        progress: 100,
        // 音量记录
        hornRecord: 100,
        // 视频播放开关,默认暂停
        playOnOff: false,
        // 是否全屏
        fullscreenOnOff: false
      },
      playerOptions: {
        height: '374',
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4',
          src: 'http://1258726060.vod2.myqcloud.com/fba2b24fvodtranscq1258726060/791c6fcd5285890810817388025/v.f30.mp4'
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      timer: null // 定时器
    }
  },
  created () {
    console.log('购买')
    if (this.detail.price !== '0.00') {
      this.playerOptions.autoplay = false
      this.videoLoading = false
    } else {
      this.playerOptions.autoplay = true
    }
    this.playerOptions.poster = this.bgImg
    // 控制空格键
    this.spaceKeyup()
    // 播放器设置
    for (let i = 0; i < this.srcArr.length; i++) {
      if (this.srcArr[i].type === 'hd') {
        this.playerOptions.sources[0].src = this.srcArr[i].url
      }
    }
    // const vueThat = this
    // vueThat.timer = setTimeout(() => {
    //   vueThat.videoPalyer()
    // }, 2000)
  },
  // 离开页面
  destroyed () {
    // 销毁enter事件
    this.spaceKeyupDestroyed()
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    // 点击购买弹窗
    buyMoney () {
      console.log('购买')
      this.$alert('本视频为付费视频，请您下载APP，完成支付！', '温馨提示', {
        type: 'error',
        confirmButtonText: '下载APP',
        showClose: true
      }).then(() => {
        const routeData = this.$router.resolve({
          path: '/down'
        })
        window.open(routeData.href, '_blank')
      })
    },
    // 初始播放设置
    initialPlay () {
      this.$refs.videoPlayer.player.src(this.srcArr.hd)
    },
    // 播放器播放
    videoPalyer () {
      if (this.detail.price !== '0.00') {
        this.buyMoney()
      } else {
        if (this.liveBtnList.playOnOff) {
          this.$refs.videoPlayer.player.pause()
          this.liveBtnList.playOnOff = false
        } else {
          this.$refs.videoPlayer.player.play()
          this.liveBtnList.playOnOff = true
        }
      }
    },
    // 监控空格键
    spaceKey (event) {
      const componentName = this.$options.name
      if (componentName === 'video') {
        const code = event.keyCode
          ? event.keyCode
          : event.which
            ? event.which
            : event.charCode
        if (code === 32) {
          event.returnValue = false
          if (this.liveBtnList.playOnOff === false) {
            this.$refs.videoPlayer.player.play()
            this.liveBtnList.playOnOff = true
          } else {
            this.$refs.videoPlayer.player.pause()
            this.liveBtnList.playOnOff = false
          }
        }
      }
    },
    // 消除空格键
    spaceKeyupDestroyed () {
      document.removeEventListener('keydown', this.spaceKey)
    },
    // 添加空格键
    spaceKeyup () {
      document.addEventListener('keydown', this.spaceKey)
    },
    // 跳转详情
    jump (type, id, navId, isDoing) {
      this.mycommon.allJump(this, type, id, navId, isDoing)
    },
    // 监听播放状态改变
    playerStateChanged (player) {
      // if (player.play) {
      //   console.log('播放状态: 开始播放')
      // }
      // if (player.pause) {
      //   console.log('播放状态: 暂停播放')
      // }
    },
    // 在线播放
    onPlayerPlay (player) {
      if (this.detail.price !== '0.00') {
        this.videoLoading = false
      } else {
        this.liveBtnList.playOnOff = true
        this.videoLoading = false
      }
    },
    // 播放暂停
    onPlayerPause (player) {
      this.videoLoading = false
      this.liveBtnList.playOnOff = false
    },
    // 在线等待
    onPlayerWaiting (player) {
      if (this.liveBtnList.playOnOff) {
        this.videoLoading = true
      }
      console.log('在线等待', player)
    },
    // 继续播放
    onPlayerPlaying (player) {
      if (this.liveBtnList.playOnOff) {
        this.videoLoading = false
      }
      if (this.detail.price !== '0.00') {
        this.buyMoney()
        this.$refs.videoPlayer.player.pause()
      }
      console.log('继续播放', player)
    },
    // 加载数据
    onPlayerLoadeddata (player) {
      if (this.detail.price !== '0.00') {
        this.videoLoading = false
      } else {
        this.videoLoading = true
      }
      console.log('加载中呢', player)
    },
    // 直播结束
    onPlayerEnded (player) {
      // console.log('视频结束', player)
    },
    // 当前播放位置发生变化时触发
    onPlayerTimeupdate (player) {
      // console.log(player)
    }
  }
  // beforeDestroy () {
  //   clearTimeout(this.timer)
  // }
}
</script>

<style>
</style>
